import { todayBusinessDate } from '@nudool/shared';

export function parseMonthParam(raw: unknown, now = new Date()): string {
  if (typeof raw === 'string') {
    const match = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(raw);
    if (match && Number(match[1]) >= 1970 && Number(match[1]) <= 2100) return raw;
  }
  return todayBusinessDate(now).slice(0, 7);
}
